import { createTheme  } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';

const Theme = {
  palette: {
    primary: {
      main: '#015289',
      light: '#01528933',
      dark: '#151540',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#E1D6BB',
      light: '#E1D6BB33',
      dark: '#005b8e',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#D64045',
    },
    warning: {
      main: '#F2B41B',
    },
    success: {
      main: '#5FAB80',
    },
    info: {
      main: '#233B57',
    },
    white: {
      main: '#FFFFFF',
      dark: '#f4f4f4',
      contrastText: '#000',
    },
    black: {
      main: '#000',
      semilight: '#999', 
      light: '#AAA', 
      contrastText: '#FFF',
    },
  },
  typography: {
    fontFamily: '"Poppins", Arial, sans-serif',
    htmlFontSize: 16,
    h1: {
      fontFamily: '"Poppins", Arial, sans-serif',
      fontSize: '3rem',
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: 0.84,
      textTransform: 'initial',
    },
    h2: {
      fontFamily: '"Poppins", Arial, sans-serif',
      fontSize: 26,
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: '32px',
      textTransform: 'initial',
    },
    h3: {
      fontFamily: '"Poppins", Arial, sans-serif',
      fontSize: 13,
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: 1.1,
      textTransform: 'initial',
    },
    h4: {
      fontFamily: '"Bebas Neue", Arial, sans-serif',
      fontSize: 14,
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: 1.1,
    },
    h5: {
      fontFamily: '"Poppins", Arial, sans-serif',
      fontSize: 14,
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: '22px',
    },
    h6: {
      fontFamily: '"Poppins", Arial, sans-serif',
      fontSize: '1.2rem',
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: 1.25,
    },
    body1: {
      fontFamily: '"Poppins", Arial, sans-serif',
      fontSize: 14,
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: '22px',
    },
    body2: {
      fontFamily: '"Poppins", Arial, sans-serif',
      fontSize: '1.2rem',
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: 1.4,
    },
    subtitle1: {
      fontFamily: '"Poppins", Arial, sans-serif',
      fontSize: '1.15rem',
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: 1.4,
    },
    subtitle2: {
      fontFamily: '"Poppins", Arial, sans-serif',
      fontSize: '1rem',
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: 1.35,
    },
    button: {
      fontFamily: '"Poppins", Arial, sans-serif',
      fontSize: 15,
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: '29px',
      textTransform: 'none',
    },
    overline: {
      fontFamily: '"Poppins", Arial, sans-serif',
      fontSize: 15,
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: '29px',
    },
    caption: {
      fontFamily: '"Poppins", Arial, sans-serif',
      fontSize: '0.9rem',
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: 1.2857,
    },
  },
  components: {
    MuiChip: {      
      styleOverrides: {
        root: {
          paddingLeft: 12,
        },
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: 'display'},
          style: {            
            display: 'inline-block',
            textTransform: 'capitalize',
            padding: '8px 16px',
            margin: '8px !important',
            backgroundColor: '#4777AE',
            color: '#FFFFFF',
            minWidth: 100,
            textAlign: 'center',
            pointerEvents: 'none',
          },
        },
      ],
    },
  },
};

export default createTheme(Theme, frFR);
